import type {
  PractitionerCredentialDto,
  PractitionerProfileDto,
  PractitionerPublicCredentialDto,
  PractitionerPublicProfileDto,
} from "cmw-client";

export type PractitionerCardSource = PractitionerProfileDto | PractitionerPublicProfileDto;

export type PractitionerCardCredential = PractitionerCredentialDto | PractitionerPublicCredentialDto;

export const isAdminSource = (source: PractitionerCardSource): source is PractitionerProfileDto => "id" in source;

export const isCredentialVerified = (credential: PractitionerCardCredential): boolean =>
  "status" in credential ? credential.status === "active" : credential.isVerified;
